// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"bc9b85da","513":"5f065416","703":"33e3cb15","787":"1dc62077"}[chunkId] + ".chunk.js";
};